import Axios from 'axios';


let AuthService = {};

(function () {
    this.loginWithGoogle = function (googleTokenId){
        const url = `${process.env.VUE_APP_API_URL}/auth/google`;
        const body = { TokenGoogle: googleTokenId, Client: "web" };
        return Axios.post(url, body);
      };

}).apply(AuthService);

export default AuthService;
